import { filesQuantFormats } from "../../../utils/utils"
import { StaticFileViewer } from "../../molecules/viewers/StaticFileViewer"

export const CreditBrazil = () => {
  const files = [
    {
      title: "Lâminas Tera Yield",
      folder: "credit-brazil/laminas-tera-yield",
      format: filesQuantFormats.HTML,
    },
    {
      title: "Acompanhamento Investidas",
      folder: "credit-brazil/acompanhamento-investidas",
      format: filesQuantFormats.HTML,
    },
    {
      title: "Credit Memos",
      folder: "credit-brazil/credit-memos",
      format: filesQuantFormats.HTML,
    },
    {
      title: "Cashflow",
      folder: "credit-brazil/Cashflow",
      format: filesQuantFormats.HTML,
    },
    {
      title: "Fila Alocação",
      folder: "credit-brazil/fila-alocacao",
      format: filesQuantFormats.HTML,
    },
  ]

  return <StaticFileViewer files={files} />
}
